export default __webpack_public_path__ + "static/media/9.7e2139f9.png";